import { render } from "./bulkInput.vue?vue&type=template&id=faf5648e"
import script from "./bulkInput.vue?vue&type=script&lang=js"
export * from "./bulkInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__